export const initPolyFill = async (): Promise<void> => {
  if (typeof window !== 'undefined') {
    if (!('IntersectionObserver' in window)) {
      await import('intersection-observer')
    }
    if (!('fromEntries' in window.Object)) {
      await import('core-js/features/object/from-entries')
    }
    if (!('DisplayNames' in window.Intl)) {
      await import('@formatjs/intl-getcanonicallocales/polyfill')
      await import('@formatjs/intl-locale/polyfill')
      await import('@formatjs/intl-displaynames/polyfill-force')
      await import(`@formatjs/intl-displaynames/locale-data/en`)
      await import(`@formatjs/intl-displaynames/locale-data/fr`)
    }
  }
}
